import "./App.css";
import Navbar from "./Compoents/Pages/Navbar/Navbar";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Home from "./Compoents/Pages/Home/Home";
import Games from "./Compoents/Pages/Games/Games";
import FaqPage from "./Compoents/Pages/Faq/FaqPage";
import Footer from "./Compoents/Pages/Footer/Footer";
import TermsAndConditions from "./Compoents/Pages/TermsAndConditions/TermsAndConditions";
import ScrollToTop from "./Compoents/Pages/ScrollTop";
import PrivacyPolicy from "./Compoents/Pages/PrivacyPolicy/PrivacyPolicy";
import FairplayPolicy from "./Compoents/Pages/FairplayPolicy/FairplayPolicy";
import ReturnPolicy from "./Compoents/ReturnPolicy/ReturnPolicy";
import Refer from "./Compoents/Pages/Refer/Refer";
import Join from "./Compoents/Pages/Join/Join";
import HowToInstallApp from "./Compoents/Pages/InstallApp/HowToInstallApp";
import ResonsTo from "./Compoents/ResonsTo/ResonsTo";
import Top_bg_color_light from "../src/New_Web_design/Top_bg_color_light.png";
import Banner from "./Compoents/Pages/Banner";
import AboutUs from "./Compoents/Pages/Aboutus/AboutUs";
import Payments from "./Compoents/Pages/Payment/Payments";
import Blog from "./Compoents/Pages/Blog/Blog";

function App() {
  document.addEventListener("contextmenu", (event) => event.preventDefault());

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <>
                <div style={{ position: "absolute", top: "0" }}>
                  <div style={{ height: "100%", width: "100%" }}>
                    <img
                      src={Top_bg_color_light}
                      alt="Top_bg_color_light"
                      style={{
                        height: "100%",
                        width: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                </div>
                <ScrollToTop />
                <div style={{ position: "relative" }}>
                  <Navbar />
                  <Home />
                </div>
                <Games />
                <Payments />
                <ResonsTo />
                <HowToInstallApp />
                <Banner />
                <AboutUs />
                <Footer />
              </>
            }
          />
          <Route path="/TermsAndConditions" element={<TermsAndConditions />} />
          <Route path="/Privacy" element={<PrivacyPolicy />} />
          <Route path="/FairplayPolicy" element={<FairplayPolicy />} />
          <Route path="/ReturnPolicy" element={<ReturnPolicy />} />
          <Route path="/Blog" element={<Blog />} />
          <Route path="/refer" element={<Refer />} />
          <Route path="/join" element={<Join />} />
          <Route
            path="/Faq"
            element={
              <>
                <Navbar />
                <ScrollToTop />
                <div
                  style={{
                    marginTop: "50px",
                  }}
                >
                  <FaqPage />
                </div>
                <Footer />
              </>
            }
          />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
